<template>
  <div class="level-wrap">
    <div class="level" :style="{width: `${levelComp}%`}" />
  </div>
</template>

<script>
import { computed, toRefs } from '@vue/composition-api';

export default {
  name: 'MicrophoneLevel',
  props: {
    level: {
      type: Number,
      default: 0,
    },
  },
  setup(props) {
    const { level } = toRefs(props);

    return {
      levelComp: computed(() => {
        const maxLevel = 0.12;
        const result = Math.ceil((level.value / maxLevel) * 100);

        return result > 100 ? 100 : result;
      }),
    };
  },
};
</script>

<style lang="scss" scoped>
  .level-wrap {
    max-width: 37.5rem;
    height: 2rem;
    background: #E0E0E0;
    border-radius: 0.25rem;
  }
  .level {
    background: #0A82D9;
    height: 100%;
    transition: width 2s;
  }
</style>
